// ng build --prod --base-href=https://sparsh.mobilisepro.com/ --output-hashing=all
export const environment = {
  production: true,
  apiUrl: 'https://sparsh.mobilisepro.com/backend/api',
  base_path: 'https://sparsh.mobilisepro.com/backend/public',
  app_url: 'https://sparsh.mobilisepro.com/#/',
  backend_url: 'https://sparsh.mobilisepro.com/backend/',
  routing: 'https://sparsh.mobilisepro.com',
  isLocal: false,
  routingEnable: true,
  iot_mqtt_server_url: '',
  apiUrlsdx: 'https://sparsh.mobilisepro.com/backend/api',
  base_path_sdx: 'https://sparsh.mobilisepro.com/backend/public',
  app_urlsdx: 'https://sparsh.mobilisepro.com',
  apiUrlfin: '',
  base_path_fin: '',
  app_urlfin: '',
  ssoUrl: '',
};
